<template>
	<div>
		<Layout :transparent="true" :withImage="true" :loading="loading" :invert="true">
			<div class="page-content" v-if="item" :class="{ scrolled: scrolled }">
				<div class="d-md-flex">
					<div class="image-box pt-5 pb-5">
						<div v-if="item.image" class="image" :style="'background-image:url(' + item.image.url + ')'"></div>
					</div>

					<div class="flex-grow-1 data ">
						<h3 class="category" v-if="item.category">{{ item.category.title }}</h3>
						<h1 class="title">
							<strong>{{ item.name }}</strong>
						</h1>
						<div class="mt-3 lead-text">
							<small>
								{{ item.intro }}
							</small>
						</div>

						<div class="mt-3 mb-3 lead- only-desktop" v-if="item.salable && item.price > 0">
							<!-- <div class="badge badge-primary" v-if="item.featured">
								OPORTUNIDAD
							</div> -->
							<div class="price mt-2">
								<span class="currency">U$S</span>
								<span class="amount ml-1">{{ item.price }}</span>
								<small class="ml-1"><small>IVA INC</small></small>
							</div>

							<div class="text-secondary py-3" v-if="item.stockAvailable == 0">
								Momentaneamente sin stock.
							</div>
							<BuyButton :product="item" v-if="item.stockAvailable > 0" />
						</div>

						<div class="d-flex flex-wrap">
							<div class="btn btn-block btn-primary mt-3 btn-call" @click="callMePlease()" :class="{ callme: callme }" v-click-outside="callMePleaseClose">
								<template v-if="!callme && !sended && !sending">Te llamamos</template>
								<template v-if="callme && !sended && !sending">
									<i class="icon icon-phone invert"></i>
									<form @submit="send()">
										<input type="text" v-model="phone" ref="phoneInput" />
									</form>
									<div class="btn btn-primary" @click="send()">
										Llamame
									</div>
								</template>
								<template v-if="sending">
									<span class="text-white px-2">Enviando solcitud</span>
								</template>
								<template v-if="!sending && sended">
									<span class="text-white px-2">En breve te llamaremos!</span>
								</template>
							</div>
							<router-link
								tag="a"
								:to="`/contacto?body=${encodeURI(`Buenos días/nDeseo obtener más información acerca del vehículo ${this.item.name}/n¡Muchas gracias!`)}`"
								class="btn btn-block btn-primary mt-3 ml-2"
								v-if="!callme"
							>
								Me interesa
							</router-link>
						</div>

						<div class="mt-4">
							<b-list-group class="group bg-transparent border-none">
								<b-list-group-item class="bg-transparent " v-if="item.detail">
									<div class="group-item-head" v-b-toggle="`collapse-description`">
										<strong>Descripción</strong>

										<div class="chevron chevron-bottom"></div>
									</div>
									<b-collapse visible :id="`collapse-description`" class="mt-2">
										<div v-html="item.detail" class="p-2"></div>
									</b-collapse>
								</b-list-group-item>

								<b-list-group-item class="bg-transparent " v-if="item.equipment">
									<div class="group-item-head" v-b-toggle="`collapse-equipment`">
										<strong>Equipamiento</strong>

										<div class="chevron chevron-bottom"></div>
									</div>
									<b-collapse :id="`collapse-equipment`" class="mt-2">
										<div v-html="item.equipment" class="p-2"></div>
									</b-collapse>
								</b-list-group-item>

								<b-list-group-item class="bg-transparent " v-if="item.dimensions">
									<div class="group-item-head" v-b-toggle="`collapse-dimensions`">
										<strong>Dimensiones</strong>

										<div class="chevron chevron-bottom"></div>
									</div>
									<b-collapse :id="`collapse-dimensions`" class="mt-2">
										<div v-html="item.dimensions" class="p-2"></div>
									</b-collapse>
								</b-list-group-item>
							</b-list-group>
						</div>
						<div class="data-sheet mt-5" v-if="item.dataSheet">
							<div class="content">
								<h4>Ficha técnica</h4>
							</div>
							<a :href="item.dataSheet.url" target="_blank" class="btn btn-primary">
								Descargar
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="floating-buy only-mobile" v-if="item.salable && item.price > 0">
				<div class="d-flex align-center justify-content-between">
					<div class="price">
						<span class="currency">U$S</span>
						<span class="amount ml-1">{{ item.price }}</span>
						<small class="ml-1"><small>IVA INC</small></small>
					</div>
					<div>
						<BuyButton :product="item" />
					</div>
				</div>
			</div>

			<div class="container mt-5">
				<div class="row row-xs">
					<div class="col-12 col-md-6 mb-3 text-center" v-for="image in item.gallery" :key="image.id">
						<!-- <div class="gallery-image hover-effect" :style="'background-image:url(' + image.url + ')'"> -->
						<img :src="image.url" class="img-fluid" />
						<!-- </div> -->
					</div>
				</div>
			</div>
		</Layout>
	</div>
</template>

<script>
import Layout from '@/components/Layout'
import ProductCartBar from '@/components/ProductCartBar'
import BuyButton from '@/components/ecommerce/BuyButton'
import gql from 'graphql-tag'

export default {
	name: 'CarDetail',
	metaInfo() {
		return {
			title: this.item ? this.item.name : '',
		}
	},
	components: {
		Layout,
		ProductCartBar,
		BuyButton,
	},
	data() {
		return {
			loading: true,
			item: {},
			callme: false,
			phone: null,
			sending: false,
			sended: false,
			scrolled: false,
		}
	},
	mounted() {
		window.addEventListener('scroll', this.onScroll)
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.onScroll)
	},

	beforeMount() {
		if (this.$route.params.slug) {
			this.load()
		} else {
			this.$router.push('/')
		}
	},
	methods: {
		onScroll(e) {
			const dataContent = document.getElementsByClassName('data')[0]
			if (dataContent) {
				let diff = 0
				if (dataContent.clientHeight > window.innerHeight) {
					diff = dataContent.clientHeight - window.innerHeight
				}
				diff = diff + 100

				window.top.scrollY > diff ? (this.scrolled = true) : (this.scrolled = false)
			}
		},
		callMePlease() {
			this.callme = true
			this.$nextTick(() => {
				this.$refs.phoneInput.focus()
			})
		},
		callMePleaseClose() {
			this.callme = false
		},
		load() {
			return this.$apollo
				.query({
					query: gql`
						query($slug: String) {
							product(slug: $slug) {
								id
								name
								featured

								image {
									id
									type
									filename
									url
									urlThumb
								}
								gallery {
									id
									type
									filename
									url
									urlThumb
								}
								dataSheet {
									id
									type
									filename
									url
									urlThumb
								}
								category {
									id
									title
								}
								intro
								detailTitle
								detail
								equipment
								dimensions
								salable
								price
								stockAvailable
							}
						}
					`,
					variables: { slug: this.$route.params.slug },
					fetchPolicy: 'network-only',
				})
				.then(({ data }) => {
					this.item = data.product
					this.loading = false
				})
				.catch((err) => {
					console.log(err)
					this.$router.push('/')
				})
		},
		send() {
			if (!this.sending && this.phone) {
				this.sending = true
				const data = {
					subject: 'Solcitud de llamada',
					name: 'No definido',
					phone: this.phone,
					email: 'No definido',
					message: `Interesado en vehículo ${this.item.name} solciita ser llamado al teléfono ${this.phone}`,
				}

				this.$apollo
					.mutate({
						mutation: gql`
							mutation($data: MessageInput!) {
								messageCreate(data: $data) {
									id
								}
							}
						`,
						variables: {
							data,
						},
					})
					.then(() => {
						this.sending = false
						this.sended = true
					})
					.catch((error) => {
						this.parseGQLErrors(error)
						this.sending = false
					})
			}
		},
	},
}
</script>

<style scoped>
.lead-text {
	font-size: 24px;
}
/* .car-head {
	display: block;
	align-items: center;
	justify-content: space-between;
} */
.image-box {
	background-color: #fff;
	width: 100%;
	flex-grow: 0;
	flex-shrink: 0;
	display: flex;
}
.image {
	width: 100%;
	max-width: 480px;
	margin: auto;
	height: 50vw;
	max-height: 640px;
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center center;
	position: relative;
}

.data {
	padding: 32px 24px;
}

.category {
	font-size: 24px;
	text-transform: uppercase;
	color: #333;
}

.badge-primary {
	background-color: #ec9721;
	border-radius: 20px;
	font-size: 14px;
	font-weight: 500;
}

.price {
	font-size: 20px;
}
.price .currency {
	font-size: 20px;
	font-weight: 600;
}
.price .amount {
	font-size: 26px;
	font-weight: 600;
}

.btn.btn-call {
	height: 44px;
	transition: all 0.3s ease-in-out;
}
.btn.callme {
	display: flex;
	padding: 4px;
	align-items: center;
	background-color: #000000;
}
.btn.callme input {
	border-radius: 20px;
	border: none;
	height: 34px;
	padding-left: 12px;
	width: 120px;
	font-size: 18px;
	margin: 0px 6px;
	outline: none;
}
.btn.callme .icon {
	margin-left: 8px;
	width: 20px;
	height: 20px;
	margin-right: 6px;
}
.btn.callme .btn-primary {
	background-color: #5a5a5a;
	color: #fff;
	height: 34px;
	align-items: center;
	padding: 0px 12px;
}

.gallery {
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
}
.gallery .item {
	width: 100%;
	padding: 40%;
	margin-bottom: 6px;
	background-color: #f3f3f3;
	background-size: cover;
	background-position: center center;
	background-repeat: no-repeat;
}

.detail-text /deep/ ul li {
	font-size: 20px;
	color: rgb(0, 0, 0);
	margin: 8px 8px 14px 8px;
}

.data-sheet {
	display: flex;
	align-items: center;
}
.data-sheet .content {
	padding: 22px 15px;
	position: relative;
	background-color: #f3f3f3;
	flex-grow: 1;
}
.data-sheet .content:before {
	content: '';
	border-top: 0px solid transparent;
	border-left: 26px solid transparent;
	border-bottom: 120px solid white;
	position: absolute;
	top: 0px;
	right: 0px;
}
.data-sheet h4 {
	font-weight: bold;
}
.data-sheet .btn {
	margin-left: 30px;
}

.floating-buy {
	position: fixed;
	z-index: 1000;
	bottom: 0px;
	left: 0px;
	width: 100%;
	background-color: #fff;
	padding: 16px;
	border-top: 1px solid rgba(0, 0, 0, 0.125);
}

@media (min-width: 750px) {
	.page-content:not(.scrolled) .image-box {
		position: fixed;
		top: 0px;
		left: 0px;
		width: 50vw;
		height: 100vh;
	}

	.page-content .image-box {
		width: 50vw;
	}

	.page-content .data {
		padding: 180px 32px;
	}
	.page-content:not(.scrolled) {
		margin-left: 50vw;
		width: calc(50vw - 18px);
	}

	.gallery {
		display: grid;
		grid-gap: 20px;
		grid-template-areas:
			'one two'
			'one three'
			'four four';
		grid-template-columns: 1fr 1fr;
		grid-template-rows: 1fr 1fr;
		width: 100%;
		height: 100%;
	}
	.gallery .item {
		padding: 0px;
	}
	.gallery .item:first-child {
		height: 64vw;
		grid-area: one;
	}
	.gallery .item:nth-child(2) {
		grid-area: two;
	}
	.gallery .item:nth-child(3) {
		grid-area: three;
	}
	.gallery .item:nth-child(4) {
		height: 24vw;
		grid-area: four;
	}
}
</style>
